import { useQuery, useQueryClient } from "@tanstack/react-query";
import {
  ApiError,
  ApiServiceError,
  GetListRequestParams,
  GetListResponse
} from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { IOffer } from "../../offers.types";
import { requestGetOffers } from "./getOffers.request";

const useOffers = (
  requestParams: GetListRequestParams,
  options?: QueryOptions<GetListResponse<IOffer>, ApiServiceError<ApiError>>
) => {
  const queryClient = useQueryClient();

  const queryKey = ["special-offers", "admin", "all", requestParams];

  const { data, ...rest } = useQuery({
    queryKey,
    queryFn: async () => await requestGetOffers(requestParams),
    ...options
  });

  const setOffers = (newOffers: IOffer[]) => {
    queryClient.setQueriesData(queryKey, {
      data: newOffers,
      meta: data?.meta
    });
  };

  return { offers: data?.data ?? [], meta: data?.meta, setOffers, ...rest };
};

export default useOffers;
